import qs from 'querystring'
import request from '@/utils/request'
import { API_PREFIX } from '@/utils/constants'

/**
 * @api /api/v1.Admin/adminList
 * @method GET
 * @description 获取管理员列表
 *
 */
export async function findAdmins() {
  try {
    const res = await request.get(`${API_PREFIX}/api/v1.Admin/adminList`)
    return res.data.map((item, index) => ({
      index: index + 1,
      id: item.id,
      username: item.userName,
      name: item.name,
      mobilePhone: item.mobile,
      isSuperAdmin: !!item.superAdmin,
    }))
  } catch (e) {
    return []
  }
}

/**
 * @api /api/v1.Admin/staffNotInAdmin
 * @method GET
 * @description 获取不是管理员的用户列表
 *
 * @param {number} page 页码
 * @param {number} total 每页记录数
 * @param {string} search 搜索关键字
 *
 */
export async function findExternalStaffs(params) {
  try {
    const query = {
      page: params.page,
      total: params.pageSize,
    }
    if (params.keyword) {
      query.search = params.keyword
    }
    const qstr = qs.stringify(query)
    const res = await request.get(`${API_PREFIX}/api/v1.Admin/staffNotInAdmin?${qstr}`)
    const paginate = res.data.page
    const list = res.data.data
    return {
      page: paginate.current_page,
      pageSize: paginate.per_page,
      total: paginate.total,
      totalPages: paginate.last_page,
      results: list.map((item, index) => ({
        index: (paginate.current_page - 1) * paginate.per_page + index + 1,
        id: item.id,
        username: item.userName,
        name: item.name,
        mobilePhone: item.mobile,
      })),
    }
  } catch (e) {
    return {
      page: params.page,
      pageSize: params.pageSize,
      total: 0,
      totalPages: 1,
      results: [],
    }
  }
}

/**
 * @api /api/v1.Admin/addAdmin
 * @method POST
 * @description 添加管理员
 *
 * @param {number[]} userids
 *
 */
export async function add(params) {
  try {
    const query = {
      userids: params.ids,
    }
    await request.post(`${API_PREFIX}/api/v1.Admin/addAdmin`, query)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Admin/delAdmin
 * @method GET
 * @description 删除管理员
 */
export async function remove(params) {
  try {
    const query = {
      userid: params.id,
    }
    const qstr = qs.stringify(query)
    await request.get(`${API_PREFIX}/api/v1.Admin/delAdmin?${qstr}`)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Admin/sendSuperadminSms
 * @method GET
 * @description 移交超级管理员发送验证码
 *
 */
export async function sendVerificationCode() {
  try {
    await request.get(`${API_PREFIX}/api/v1.Admin/sendSuperadminSms`)
    return true
  } catch (e) {
    return false
  }
}

/**
 * @api /api/v1.Admin/turnOverSuperAdmin
 * @method GET
 * @description 移交超级管理员
 *
 * @param {number} userid 新超级管理员 ID
 * @param {string} captcha 短信验证码
 *
 */
export async function transferSuperAdmin(params) {
  try {
    const query = {
      userid: params.selected,
      captcha: params.verificationCode,
    }
    const qstr = qs.stringify(query)
    await request.get(`${API_PREFIX}/api/v1.Admin/turnOverSuperAdmin?${qstr}`)
    return true
  } catch (e) {
    return false
  }
}
